import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy , inject} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { PrecioCombustible, TipoPrecioCombustible } from '@/app/models/PrecioCombustible';
import { PreciosService } from '@/app/services/precios.service';
import { TokenReaderService } from '@/app/services/security/token-reader.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-precio-contenido',
    templateUrl: './precio-contenido.component.html',
    styleUrls: ['./precio-contenido.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrecioContenidoComponent implements OnInit {
  private spinner = inject(NgxSpinnerService);

  @Output() responseContent = new EventEmitter<boolean>();

  //validaciones
  hasFinished: boolean = false;

  //REQUEST
  @Input() formContent: TipoPrecioCombustible = {
    precio: '',
    tipo: ''
  };


  //historial
  listaHistoria: PrecioCombustible[] = [];


  constructor(
    private toastr: ToastrService,
    private router: Router,
    private preciosService: PreciosService,
    private userTokenReader: TokenReaderService,
  ){
  }

  ngOnInit(): void {
    this.getHistorial();
  }

  getHistorial(){
    this.preciosService.getPrecios(this.formContent.tipo).subscribe({
     next: (data: any) => {
      if(data != null && data.Precios != null){
        this.listaHistoria = data.Precios;
      }
     },
     error: (err) => {
      if(err.status == 401){
        this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
        this.router.navigate(['/login']);
      }else{
        if(err.error){
          let { ClassInfo } = err.error;
          this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
        }
      }
      console.log(err);
     } 
    });
  }

  formSubmit(form: NgForm){
    if(form.valid){
      Swal.fire({
        title: 'Confirmar',
        text: "¿Deseas guardar el precio?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#1c869e ',
        cancelButtonColor:  '#999999',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Regresar',
        allowOutsideClick: true,
        reverseButtons: true
      }).then((result) => { 
        if(result.value){
          this.insertPrecioCombustible();
        }
      });
    }
  }

  insertPrecioCombustible(){
    this.spinner.show();

    let request = {
      precio: this.formContent.precio,
      creadoPor: this.userTokenReader.getUserData().idUsuario,
      fechaCreacion: new Date(),
    }

    this.preciosService.insertPrecioCombustible(request, this.formContent.tipo).subscribe({
      next: (data: any)=>{
        this.spinner.hide();
        Swal.fire(
          'Éxito',
          'Precio guardado correctamente.',
          'success'
        ).then(result=>{
          this.hasFinished = true;
          this.onClose();
        });
      },
      error: (err) =>{
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }


  onClose(){
    if(!this.hasFinished){
      Swal.fire({
        title: 'Alerta',
        text: "No se ha guardado los cambios. ¿Seguro que deseas salir?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#999999',
        cancelButtonColor:  '#1c869e',
        confirmButtonText: 'Salir',
        cancelButtonText: 'No salir',
        allowOutsideClick: false,
        reverseButtons: false
      }).then((result) => {
        if(result.value){
          this.responseContent.emit(false)
        }
      });
    } else{
      this.responseContent.emit(true)
      //this.getHistorial();
    }
  }
}
